import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import * as error from '../../shared/components/error-summary/error-handler.function';
import { Booking, Pass, Addon, FlattenedAddon, CreateBookingOptions, FareTypeOption, Package, AddonOption, OptionValueEntityInstance } from '../models/booking.model';
import { PassengerFormModel } from '../models/passenger.model';
import { PaymentItem } from '../models/booking.model';
import { Availability } from 'app/shared/models/availability.model';
import { InitialDataService } from 'app/initial-data.service';
import { AddonsService } from 'app/shared/services/addons.service';
import { GxConstants } from 'app/shared/constants/gx.constants';
import * as _ from 'lodash';
import { CreateBookingsOption } from './travel-product.service';

@Injectable()
export class BookingService {

    public bookingsSource = new BehaviorSubject(Array<Booking>());
    bookings = this.bookingsSource.asObservable();

    constructor(private http: Http,
        public initialDataService: InitialDataService,
        private addonsService: AddonsService) { }

    setBookings(b: Array<Booking>, clear: boolean = true){
        this.clearBookings(clear);
        let bookings: Array<Booking> = [];
        this.bookingsSource.value.forEach(booking => {
            bookings.push(booking);
        })
        b.forEach(booking => {
            bookings.push(booking);
        })
        this.bookingsSource.next(bookings);
    }

    setBooking(b: Booking, clear: boolean = true){
        this.clearBookings(clear);
        let bookings: Array<Booking> = [];
        this.bookingsSource.value.forEach(booking => {
            bookings.push(booking);
        })
        bookings.push(b);
        this.bookingsSource.next(bookings);
    }

    private clearBookings(clear: boolean = false) {
        if(clear){
            this.bookingsSource.next(new Array<Booking>());
        }
    }

    getBookingViaLogin = (options: GetBookingViaLoginOption) => {
        const url = `/umbraco/api/booking/GetBookingViaLogin`;
        return this.http.post(url, options)
            .map(this.extractJson)
            .catch(error.handleError);
    }
    getBookingV2 = (bookingGuid) => {
        const url = `/umbraco/api/booking/getBookingV2?bookingGuid=${bookingGuid}`;
        return this.http.get(url)
            .map(this.extractJson)
            .catch(error.handleError);
    }
    getBookingViaLoginWithPassMargin = (options: GetBookingViaLoginOption) => {
        const url = `/umbraco/api/booking/GetBookingViaLoginWithPassMargin`;
        return this.http.post(url, options)
            .map(this.extractJson)
            .catch(error.handleError);
    }
    addSectorAndCommit = (options: SectorOptions) => {
        return this.http.put('/umbraco/api/booking/AddSectorAndCommit', options)
            .map(this.extractJson)
            .catch(error.handleError);
    }
    addSector = (options: SectorOptions) => {
        const url = '/umbraco/api/booking/addSector';
        return this.http.put(url, options)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    deleteSector = (options: DeleteSectorOptions) => {
        const url = `/umbraco/api/booking/DeleteSector?bookingGuid=${options.bookingGuid}&sectorNumber=${options.sectorNumber}`;
        return this.http.delete(url)
            .map(this.extractJson)
            .catch(error.handleError);

    }
    updateSector = (options: SectorOptions) => {
        return this.http.put('/umbraco/api/booking/updateSector', options, null)
            .map(this.extractJson)
            .catch(error.handleError);
    }
    
    deleteSectorByGuid = (options: DeleteSectorByGuidOptions) => {
        const url = `/umbraco/api/booking/DeleteSectorByGuid?bookingGuid=${options.bookingGuid}&sectorGuid=${options.sectorGuid}`;
        return this.http.delete(url)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    deleteTourByGuid = (options: DeleteTourByGuidOptions) => {
        const url = `/umbraco/api/booking/DeleteTourByGuid?bookingGuid=${options.bookingGuid}&tourGuid=${options.tourGuid}`;
        return this.http.delete(url)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    getGoogleTagsTransactionDetails = (bookingGuid: string) => {
        const url = `/umbraco/api/booking/getECommerceForBooking?bookingGuid=${bookingGuid}`;
        return this.http.get(url)
            .map(this.extractJson)
            .catch(error.handleError);
    }

    getBookings(bookingGuid: string): Observable<Array<Booking>> {
        const getBookingsUrl = '/umbraco/api/booking/GetBooking';
        return this.http.get(`${getBookingsUrl}?bookingGuid=${bookingGuid}`)
            .map(res => res.json())
            .catch(error.handleError);
    }
    getPassCreateBookingOptions = (passAsAPackage: Package,
        cartTotalPaymentItems: Array<PaymentItem>,
        passengerOption: PassengerRequest,
        addons: Array<Addon>,
        promoCode: string,
        bookingGuid: string) => {

        const farebasis = passAsAPackage.FareTypes[0].Farebasis,
            option: CreateBookingOptions =
                this.hydrateExpressCreateBookingOptions(passengerOption, addons, cartTotalPaymentItems, bookingGuid);
        const ref = passAsAPackage.PackageReference;
        option.Pass = new PassOptions(ref, farebasis.FarebasisCode, promoCode);
        return option;
    }
    create = (options) => {
        console.log(options);
        return this.http.post('/umbraco/api/booking/create', options, null)
         .map(res => res.json())
        .catch(error.handleError);
    }
    getExpressCreateBookingOptions = (cartTotalPaymentItems: Array<PaymentItem>,
        addons: Array<Addon>,
        travels: Array<Availability>,
        passengerOption: PassengerRequest,
        selectedLoyaltyProgram: number,
        customerWishsToUseFreeTrip: boolean) => {

        const option: CreateBookingOptions = this.hydrateExpressCreateBookingOptions(passengerOption, addons, cartTotalPaymentItems, null);
        option.Travels = _.map(travels,
            (travel) => {
                return new GetTravelOptions(travel.TravelGUID, travel.RouteOptions[0].Fares[0].FareGUID);
            });
        option.SelectedLoyaltyProgram = selectedLoyaltyProgram;
        option.CustomerWishsToUseFreeTrip = customerWishsToUseFreeTrip;
        return option;
    }

    getAddons = (options) => {
        return this.http.post('/umbraco/api/booking/addons', options, null)
        .map(res => res.json())
        .catch(error.handleError);
    }
    addAddonsToBooking = (options) => {
        return this.http.put('/umbraco/api/booking/AddAddonsToBooking', options, null)
        .map(res => res.json())
        .catch(error.handleError);
    }
    addAddonsToBookingV1 = (options) => {
        return this.http.put('/umbraco/api/booking/AddAddonsToBookingV1', options, null)
        .map(res => res.json())
        .catch(error.handleError);
    }
    private extractJson(res: Response) {
        return res.json();
    }
    private hydrateExpressCreateBookingOptions = (passengerOption: PassengerRequest,
        addons: Array<Addon>,
        cartTotalPaymentItems: Array<PaymentItem>,
        bookingGuid: string): CreateBookingOptions => {

            console.log('addons');
            console.log(addons);
        const flattenedAddonAnswers = this.addonsService.getAddonsAnswers(addons),
            addonBreakdown = this.getAddonBreakdown(flattenedAddonAnswers || [], cartTotalPaymentItems);

            console.log('flattenedAddonAnswers');
            console.log(flattenedAddonAnswers);
        const insurance = addonBreakdown.insurance,
            thirdPartyAddons = addonBreakdown.thirdPartyAddons,
            otherAddons = addonBreakdown.addons,
            processingFee = addonBreakdown.processingFee,
            customerGuid = !!this.initialDataService.userData ? this.initialDataService.userData.CustomerGuid : null,
            option = new CreateBookingOptions();

        option.Passenger = passengerOption;

        option.InsuranceAmount = !!insurance ? insurance.salePriceUnit : 0;
        option.ProcessingFeeAmount = !!processingFee ? processingFee.Total : 0;
        option.ThirdPartyAddons = _.map(thirdPartyAddons, this.toFareTypeOption);
        option.Addons = _.map(otherAddons, this.toFareTypeOption);
        option.CustomerGuid = customerGuid;
        option.BookingGuid = bookingGuid;
        return option;
    }

    private getAddonBreakdown = (rawAddons: Array<FlattenedAddon>,
        cartTotalPaymentItems: Array<PaymentItem>) => {

        const insuranceCode = GxConstants.FARETYPE_CODES.INSURANCE,
            taxCode = GxConstants.FARETYPE_CODES.TAX_BACK,
            tpCode = GxConstants.FARETYPE_CODES.THIRD_PARTY,
            feeCode = GxConstants.FARETYPE_CODES.PROCESSING_FEE;
        const insurance = _.find(rawAddons,
            (addon) => {
                return addon.Type === insuranceCode;
            }),
            addons = _.filter(rawAddons,
                (addon) => {
                    return addon.Type === taxCode;
                }),
            thirdPartyAddons = _.filter(rawAddons,
                (addon) => {
                    return addon.Type === tpCode && !!addon.productCode;
                }),
            processingFee = _.find(cartTotalPaymentItems,
                (paymentItem) => {
                    return paymentItem.Sku === feeCode;
                });
        return new AddonBreakdown(insurance, addons, thirdPartyAddons, processingFee);
    }
    private toFareTypeOption = (addon) => {
        return new FareTypeOption(addon.salePriceUnit, addon.Type, addon.productCode, addon.usageDate);
    }
}

export class GetBookingViaLoginOption {
    constructor(private bookingNumber: string, private bookingPin: string) { }
}

export class GetTravelOptions {
    constructor(public travelGUID: string, public fareGUID: number) { }
}

export class SectorOptions extends GetTravelOptions {
    constructor(public bookingGuid: string, travelGUID: string, fareGUID: number, public sectorNumber?: number) {
        super(travelGUID, fareGUID);
    }
}

export class DeleteSectorOptions {
    constructor(public bookingGuid: string, public sectorNumber: number) { }
}

export class DeleteSectorByGuidOptions {
    constructor(public bookingGuid: string, public sectorGuid: string) { }
}
export class DeleteTourByGuidOptions {
    constructor(public bookingGuid: string, public tourGuid: string) { }
}
export class PassengerRequest {
    Address: string;
    CustomerID: number;
    City: string;
    Concession: string;
    Concession2: string;
    Country: string;
    DOB: Date;
    Email: string;
    FemaleCount: number;
    FirstName: string;
    Gender: string;
    MaleCount: number;
    Phone: string;
    PassengerGuid: string;
    PostCode: string;
    SATypeDescription: string;
    SpecialAssistanceId: number;
    State: string;
    Surname: string;
    Title: string;
    NursedInfantCount: number;

    constructor(passenger: PassengerFormModel,
        specialAssistanceType: number,
        nursedInfant: number,
        malesCount: number,
        femalesCount: number,
        passengerGuid: string) {
        if (passenger.studentCount === 1 && passenger.concessionCount === 1) {
            this.Concession = passenger.concessionCard1;
            this.Concession2 = passenger.studentCard1;
        } else if (passenger.studentCount === 1 && passenger.concessionCount === 0) {
            this.Concession = passenger.studentCard1;
            this.Concession2 = passenger.studentCard2;
        }  else if (passenger.studentCount === 2 && passenger.concessionCount === 0) {
            this.Concession = passenger.studentCard1;
            this.Concession2 = passenger.studentCard2;
        } else {
            this.Concession = passenger.concessionCard1;
            this.Concession2 = passenger.concessionCard2;
        }

        this.SpecialAssistanceId = specialAssistanceType;
        this.MaleCount = malesCount;
        this.FemaleCount = femalesCount;
        this.Gender = passenger.gender;
        this.Country = passenger.country;
        this.Email = passenger.email;
        this.FirstName = passenger.firstName;
        this.Surname = passenger.surname;
        this.Phone = passenger.phone;
        this.PassengerGuid = passengerGuid;
    }
}

export class PassOptions {
    constructor(public PassReference: string, public FareTypeCode: string, public PromoCode: string) { }
}
export class AddonBreakdown {
    constructor(public insurance: FlattenedAddon,
        public addons: Array<FlattenedAddon>,
        public thirdPartyAddons: Array<FlattenedAddon>,
        public processingFee: PaymentItem) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/booking.service.ts